/*
  Bundle star ratings = the review-count-weighted average of the bundle's
  component products (i.e. the average of every review across them).

  Liquid can't read a native Shopify bundle's components, and the tokenless
  Storefront API can't read Judge.me's metafields, so this combines the two:
    1. components (product handles) from the Storefront API
    2. each component's rating + review count from
       /products/<handle>?view=rating (templates/product.rating.liquid)

  Fills any element with [data-bundle-rating]:
    data-bundle-rating="card"  -> stars + "4.60 out of 5" (product cards)
    data-bundle-rating="stars" -> stars only (PDP "Store rating" block)
  plus data-product-handle, data-variant-id and data-fallback-rating (the
  store-wide average, used if anything fails). Results are cached for the
  session so revisiting a page doesn't refetch.
*/
(function () {
  if (window.FabtabBundleRating) return;

  var CACHE_PREFIX = 'fabtab-bundle-rating:v1:';
  var pending = {};

  function cacheGet(key) {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_PREFIX + key));
    } catch (e) {
      return null;
    }
  }

  function cacheSet(key, value) {
    try {
      sessionStorage.setItem(CACHE_PREFIX + key, JSON.stringify(value));
    } catch (e) {}
  }

  function fetchComponentHandles(handle, variantId) {
    var query =
      'query($handle: String!) { product(handle: $handle) { variants(first: 100) { nodes { id components(first: 50) { nodes { productVariant { product { handle } } } } } } } }';
    return fetch('/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: { handle: handle } })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        var variants = json && json.data && json.data.product ? json.data.product.variants.nodes : [];
        var wanted = 'gid://shopify/ProductVariant/' + variantId;
        var variant = variants.filter(function (v) { return v.id === wanted; })[0] || variants[0];
        var handles = [];
        (variant ? variant.components.nodes : []).forEach(function (c) {
          var h = c.productVariant.product.handle;
          if (handles.indexOf(h) === -1) handles.push(h);
        });
        return handles;
      });
  }

  function fetchProductRating(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?view=rating', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); });
  }

  function getBundleRating(handle, variantId) {
    var key = handle + ':' + variantId;
    var cached = cacheGet(key);
    if (cached && typeof cached.rating === 'number') return Promise.resolve(cached);
    if (pending[key]) return pending[key];

    pending[key] = fetchComponentHandles(handle, variantId)
      .then(function (handles) {
        if (!handles.length) throw new Error('no components');
        return Promise.all(handles.map(fetchProductRating));
      })
      .then(function (ratings) {
        var total = 0;
        var count = 0;
        ratings.forEach(function (r) {
          if (r && r.count > 0 && r.rating > 0) {
            total += r.rating * r.count;
            count += r.count;
          }
        });
        if (!count) throw new Error('no reviews');
        var result = { rating: total / count, count: count };
        cacheSet(key, result);
        return result;
      });

    return pending[key];
  }

  // Same half-star rule as the Liquid stars (cstm-card-product / main-product).
  function starsHtml(rating) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var state = rating >= i ? 'on' : rating >= i - 0.5 ? 'half' : 'off';
      html += '<span class="jdgm-star jdgm--' + state + '"></span>';
    }
    return html;
  }

  // Matches Liquid's `round: 2` output (4.6, 4.57) used on the other cards.
  function formatRating(rating) {
    return String(Math.round(rating * 100) / 100);
  }

  function render(el, rating) {
    var label = formatRating(rating) + ' out of 5';
    if (el.getAttribute('data-bundle-rating') === 'stars') {
      el.innerHTML = starsHtml(rating);
      el.setAttribute('aria-label', label + ' stars');
    } else {
      el.innerHTML =
        '<span class="cstm-card__store-stars" role="img" aria-label="' + label + ' stars">' + starsHtml(rating) + '</span>' +
        '<span class="cstm-card__rating-score">' + label + '</span>';
    }
  }

  function fill(el) {
    if (el.hasAttribute('data-bundle-rating-filled')) return;
    el.setAttribute('data-bundle-rating-filled', '');
    var fallback = parseFloat(el.getAttribute('data-fallback-rating')) || 0;
    getBundleRating(el.getAttribute('data-product-handle'), el.getAttribute('data-variant-id'))
      .then(function (result) { render(el, result.rating); })
      .catch(function () { if (fallback > 0) render(el, fallback); });
  }

  function scan(root) {
    (root || document).querySelectorAll('[data-bundle-rating]:not([data-bundle-rating-filled])').forEach(fill);
  }

  window.FabtabBundleRating = { scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Cards also arrive later (collection filtering/sorting, tabbed sections,
  // carousels) -- pick those up too.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        scan();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
